export default __webpack_public_path__ + "static/media/logo.d6a7ef93.png";